/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import React from 'react'
import TysiaInputDateRange from 'DesignSystem/TysiaInputDateRange/index'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Marketing/RangeChooser/Content",
  onChange
  
}) {
let daterangeValueData = fromData.useDataValue({ viewPath,
context: 'daterange',
})
let daterangeChangeData = fromData.useDataChange({ viewPath,
context: 'daterange',
})
let daterangeTemplatesValueData = fromData.useDataValue({ viewPath,
context: 'daterange',
path: 'templates',
})
  return (<React.Fragment
>
<TysiaInputDateRange
  viewPath={`${viewPath}/TysiaInputDateRange`}
 offsetCrossAxis={-413}
 label="Date range"
 width={220}
 size="small"
 data="daterange"
 daterange={daterangeValueData}
 onChange={daterangeChangeData}
 data="daterange.templates"
 templates={daterangeTemplatesValueData}
/>
{children}
</React.Fragment>)
}